<template>
  <div class="environment-ribbon" role="status">
    <i class="fas fa-exclamation-triangle environment-ribbon__icon" aria-hidden="true"></i>
    <span>
      <strong>{{ title }}</strong>
      {{ text }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'EnvironmentRibbon',
  props: {
    country: {
      default: null,
      type: String
    },
    text: {
      default: 'Los datos son de ensayo y pueden cambiar o desaparecer.',
      type: String
    }
  },
  computed: {
    title () {
      return this.country ? `Ambiente de pruebas · ${this.country}` : 'Ambiente de pruebas'
    }
  }
}
</script>

<style lang="scss">
.environment-ribbon {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: #fdf6e3;
  border-bottom: 1px solid #e9dcb5;
  color: #5c4a12;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.4;

  &__icon {
    font-size: 12px;
  }
}
</style>
